import { StyleSheet } from "react-native";
import { colorList } from "utils/colors";

export const formStyles = StyleSheet.create({
	rowContainer: {
		marginBottom: 8,
		flex: 1,
		flexDirection: 'column'
	},
	
	row: {
		//flex: 1,
		//flexShrink: 1
	},
	
	title: {
		paddingHorizontal: 0,
		//paddingTop: 4
	},
	
	hint: {
		color: colorList.BLACK.light,
		fontSize: 12,
		paddingHorizontal: 0,
		paddingVertical: 4,
	},
	
	warning: {
		fontSize: 12,
		paddingHorizontal: 0,
		paddingVertical: 4,
		color: colorList.RED.primary
	},
});
